import * as React from 'react';

const Completed = (props) => <div>
    <br />
    <br />
    <br />
    <label className="fieldlabel" style={{ letterSpacing:"0.3px" }}>
        To lock in your ordering selections and pricing, click the &quot;SUBMIT&quot; button below.   Use the &quot;PREVIOUS&quot; button if you need to go back and make changes before you click &quot;SUBMIT&quot;.
    </label>
    <br />
    <br />
    <br />
</div>;

export default Completed;
